import React, { useEffect, useState } from 'react';
import { Modal, Tabs, Tab } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import authStore from '../../store/authStore';
import Utils from '../../helpers/Utility';
import LoadingWheel from '../loadingwheel';
import SensorService from '../../services/sensorService';
import constants from '../../config/constants';
import moment from 'moment'
import Permissions from '../../config/permssions';
import '../maintenance-checklist/maintenance-checklist.css';

const maxLimit = 16
const {
    view_only_partial_asset_sensorbox_details
} = Permissions

interface Props {
  groupData: any;
  show: boolean;
  onClose: () => void;
  groupId?: any;
  groupName? : any;
  showLogDataModal: (logData: any) => void;
}

const ConsolidatedAlarmLogs: React.FC<Props> = ({ groupData, show, groupId, groupName, onClose,
  showLogDataModal }) => {

  const [loading, setLoading] = useState(true)
  const [alertLogs, setAlertLogs] = useState<Array<any>>([])
  const [deviceLogs, setDeviceLogs] = useState<Array<any>>([])
  const [currentAlertLogPage, setCurrentAlertLogPage] = useState(1)
  const [currentDeviceLogPage, setCurrentDeviceLogPage] = useState(1)
  const [alertLogsTotal, setAlertlogsTotal] = useState(0)
  const [deviceLogsTotal, setDeviceLogsTotal] = useState(0)

  useEffect(() => {
    getGroupAlertLogs()
    getGroupDeviceAlertLogs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const getGroupAlertLogs = async (pageNumber: number = 0) => {

    if (groupId) {
      setLoading(true)
      pageNumber = pageNumber === 0 ? currentAlertLogPage : pageNumber;
      const response = await SensorService.getGroupAlertLogs(groupId, pageNumber, maxLimit)
      setAlertLogs(response.data.logs)
      setCurrentAlertLogPage(pageNumber)
      setAlertlogsTotal(response.data.total)
      setLoading(false)
    }
    
  }

    const getGroupDeviceAlertLogs = async (pageNumber: number = 0) => {

    if (groupId) {
      setLoading(true)
      pageNumber = pageNumber === 0 ? currentDeviceLogPage : pageNumber;
      const response = await SensorService.getGroupDeviceOfflineLogs(groupId, pageNumber, maxLimit)
      setDeviceLogs(response.data.logs)
      setCurrentDeviceLogPage(pageNumber)
      setDeviceLogsTotal(response.data.total)
      setLoading(false)
    }
    
  }

  const demoCheck = (authStore?.currentUser?.active_role?.role_type === -1);
  const algorithmDescriptionCheck = (item: any) => {  
    return item?.description
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
    >
      <Modal.Header  closeButton>
      <div>{groupName}</div>
      </Modal.Header>
      <Modal.Body>
        <Tabs variant="pills" className="checklist-tab mb-3">
          <Tab eventKey="status" title="Health Alerts">
            {
            <div>
            <div className="table-wrap">
              {loading ?
                <LoadingWheel />
                :
                <table className={alertLogs.length > 0 ? "table custom-table table-style-logs text-custom-size" : "table custom-table table-style-no-logs "} style={{ tableLayout: 'fixed' }}>
                  {alertLogs.length > 0 ? 
                    <>
                      <thead className="table-header-bg">
                        <tr>
                          <th style={{ width: '5%' }} scope="col">#</th>
                          <th style={{ width: '10%' }} scope="col">Sensor Box</th>
                          <th style={{ width: '6%' }} className="text-center" scope="col">Status</th>
                          <th style={{ width: '10%' }} className="text-center" scope="col">Diagnostics Code</th>
                          <th style={{ width: '49%' }} className="text-center" scope="col">Failure Mode</th>
                          <th style={{ width: '20%' }} scope="col">Alert Mail Sent On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {alertLogs.map((item: any, index) => {
                          const sensorBoxName = groupData?.sensorboxes?.find((sensor: any) => sensor.sensor_box_name === item?.sensorbox_name)
                          return (
                            <tr  className={index%2 !== 0 ? "background-color click-icon" : "click-icon"} key={index} onClick={() => { showLogDataModal(item) }}>
                              <td>{(maxLimit * (currentAlertLogPage - 1)) + index + 1}</td>
                              <td className="text-truncate" title={sensorBoxName?.sensor_box_name}>{sensorBoxName?.alias ? sensorBoxName?.alias : sensorBoxName?.sensor_box_name}</td>
                              <td className="text-center"><i className={`fa fa-circle ${Utils.getSensorStatus(item.status)}`} aria-hidden="true"></i></td>
                              <td className="text-truncate text-center" title={item?.diagnostics_code}>{item?.diagnostics_code}</td>
                              <td className="text-center" title={algorithmDescriptionCheck(item)}>{algorithmDescriptionCheck(item)}</td>
                              <td className="text-truncate">{moment(item?.timestamp).format('MM/DD/YYYY, HH:mm:ss')}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </>
                    :
                    <div>
                      <p className='no-logs-text'>No logs found</p>
                    </div>}
                </table>
              }
            </div>
            {alertLogs.length > 0 && !loading &&
            <div className={Math.ceil(alertLogsTotal / maxLimit) > 1 ? "pagination-container-logs" : "pagination-container-no-logs"}>
              {Math.ceil(alertLogsTotal / maxLimit) > 1 ?
                <Pagination
                  hideNavigation={true}
                  activePage={currentAlertLogPage}
                  itemsCountPerPage={maxLimit}
                  totalItemsCount={alertLogsTotal}
                  itemClass={"item-class"}
                  activeClass={"active-class"}
                  pageRangeDisplayed={5}
                  onChange={(pageNumber) => getGroupAlertLogs(pageNumber)}
                />
                : null
              }
            </div>
          }
          </div>
          }
          </Tab>
          <Tab eventKey="device" title="Offline Alerts">
          {
            <div>
            <div className="table-wrap">
              {loading ?
                <LoadingWheel />
                :
                <table className={deviceLogs.length > 0 ? "table custom-table table-style-logs text-custom-size" : "table custom-table table-style-no-logs "} style={{ tableLayout: 'fixed' }}>
                  {deviceLogs.length > 0 ? 
                    <>
                      <thead className="table-header-bg">
                        {authStore?.currentUser?.access?.includes(view_only_partial_asset_sensorbox_details) ?
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Sensor Box</th>
                          <th scope="col">Alert Mail Sent On</th>
                        </tr>
                        :
                        <tr>
                          <th style={{ width: '10%' }} scope="col">#</th>
                          <th style={{ width: '20%' }} scope="col">Sensor Box</th>
                          <th style={{ width: '30%' }} scope="col">Recipients</th>
                          <th style={{ width: '40%' }} scope="col">Alert Mail Sent On</th>
                        </tr>
                        }
                      </thead>
                      <tbody>
                        {deviceLogs.map((item: any, index) => {
                          const sensorBoxName = groupData?.sensorboxes?.find((sensor: any) => sensor.sensor_box_name === item?.sensorbox_name)
                          return (
                            <tr  className={index%2 !== 0 ? "background-color click-icon" : "click-icon"} key={index}>
                              <td>{(maxLimit * (currentDeviceLogPage - 1)) + index + 1}</td>
                              <td className="text-truncate" title={sensorBoxName?.sensor_box_name}>{sensorBoxName?.alias ? sensorBoxName?.alias : sensorBoxName?.sensor_box_name}</td>
                              <td className="text-truncate" title={demoCheck ? `example@gmail.com` : item.emails.toString().replace(/,/g, ', ')}>{demoCheck ? `example@gmail.com` : item.emails.toString().replace(/,/g, ', ')}</td>
                              <td className="text-truncate">{moment(item?.timestamp).format('MM/DD/YYYY, HH:mm:ss')}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </>
                    :
                    <div>
                      <p className='no-logs-text'>No logs found</p>
                    </div>}
                </table>
              }
            </div>
            {deviceLogs.length > 0 && !loading &&
            <div className={Math.ceil(deviceLogsTotal / maxLimit) > 1 ? "pagination-container-logs" : "pagination-container-no-logs"}>
              {Math.ceil(deviceLogsTotal / maxLimit) > 1 ?
                <Pagination
                  hideNavigation={true}
                  activePage={currentDeviceLogPage}
                  itemsCountPerPage={maxLimit}
                  totalItemsCount={deviceLogsTotal}
                  itemClass={"item-class"}
                  activeClass={"active-class"}
                  pageRangeDisplayed={5}
                  onChange={(pageNumber) => getGroupDeviceAlertLogs(pageNumber)}
                />
                : null
              }
            </div>
          }
          </div>
          }
          </Tab>
        </Tabs>

      </Modal.Body>
    </Modal>
  )
}

export default ConsolidatedAlarmLogs;
